import { fetch, post } from './actions';

const getProfile = fetch;
const postProfile = post;

export { getProfile, postProfile };



// WEBPACK FOOTER //
// ./src/app/models/Profile/index.ts